<template>
  <div id="weAreEDG" style=" min-height:600px;height: 100%;width: 100%;text-align: center;margin-bottom: -10px">
    <p class="content">
      20年前，我们蹒跚学步，你还未来到世上
    </p>
    <p class="content">
      10年前，我们跌宕起伏，你还在茁壮成长
    </p>
    <p class="content">
      5年前，我独自冒险，你迎来最美的时光
    </p><br>
    <p class="content">
      他们曾说，我们玩物丧志，荒废年华 &nbsp&nbsp &nbsp&nbsp &nbsp&nbsp他们预测，我们必将沉沦，失掉未来
    </p>
    <p class="content">
      他们发现，我们从未放弃，格外倔强 &nbsp&nbsp &nbsp&nbsp &nbsp&nbsp他们承认，我们朝气蓬勃，愈挫愈勇
    </p><br>
    <p class="content">
      但，彼岸未至，未来已来
    </p>
    <p class="content">
      但，我们依然年轻，并坚信不寻常才是寻常
    </p><br>
    <p class="content">
      未来，请你与我一起
    </p>
    <p class="content">
      披星戴月，走在荆棘路上
    </p>
    <p class="content">
      我们是EDG，和你一起
    </p><br><br>
   <!-- <p class="content" style="font-size: 56px;color: yellow ">
      <span style="font-size: 76px">纵</span> 情 <span style="font-size: 76px">燃烧</span>
      &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp生命<span style="font-size: 76px"> 闪 </span>耀
    </p>-->
  </div>
</template>

<script>
  export default {
    name: 'weAreEDG',
    data() {
      return {
        msg: 'We Are EDG'
      }
    },
    //监听
    watch: {},

    //事件处理
    methods: {
      requestweAreEDG: function (offset) {
        this.request.get({
          url: '/about/text',
          params: {},
          callback: function (data) {
            if (data.data.length == 0) return;
            console.log(data)
          }.bind(this)
        })
      },
    },

    //实例加载完成后
    created() {
      this.requestweAreEDG();
    },

    //页面完成以后
    mounted: function () {
      for (let i = 0; i < 11; i++) {
        setTimeout(fn(i), 1000)
      }

      function fn(num) {
        $(".content").eq(num).animate({opacity: '1'}, num * 1000);
      }

    },
  }
</script>

<style scoped>
  #weAreEDG {
    padding-top: 100px;
    background: url(../images/we-are-edg.jpg) no-repeat;
    background-size: cover;
    color: white;
    font-size: 20px;
  }

  p {
    margin: 0;
    margin-bottom: 10px;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/weAreEDG.vue